module.exports = __webpack_public_path__ + "img/iframe.48eebfdc.png";